import { ReactNode, useRef } from 'react';

import { PatientMessagingProviderWithoutRef } from './context';

interface PatientMessagingProviderProps {
  children: ReactNode;
}

export const PatientMessagingProvider: React.FC<PatientMessagingProviderProps> = (props) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <PatientMessagingProviderWithoutRef chatContainerRef={ref}>
      <div hidden ref={ref} />
      {props.children}
    </PatientMessagingProviderWithoutRef>
  );
};
